export var DRAWER_HEIGHT_CSS_VAR = '--drawer-viewport-height';
export var MODAL_HEIGHT_CSS_VAR = '--modal-viewport-height';